export type ProductType =
  | "Vacation Packages"
  | "Flight&Hotel"
  | "Hotels"
  | "Tour"
  | "Ski Package";

export enum ModifySearchMode {
  view = "view",
  update = "update",
}

export type PlayerName = "Package" | "Hotel";

export interface FlightTrip {
  origin: string;
  destination: string;
}
